export default __webpack_public_path__ + "static/media/log_out.e680967a.svg";